// src/components/BotAvatarGrid.js
import React from "react";
import { Link } from "react-router-dom";
import bots from "../botsData";

const BotAvatarGrid = () => {
  return (
    <section className="max-w-6xl mx-auto px-6 mt-14 mb-16">
      <h2 className="text-center text-3xl font-black tracking-tight text-white apb-glow-text">
        Bots we build
      </h2>
      <p className="text-center text-apb-text-secondary mt-2">
        Since <span className="text-apb-accent-cyan font-semibold">2023</span>, we've invested in{" "}
        <span className="text-apb-accent-cyan font-semibold">{bots.length}</span> bots.
      </p>

      <div className="mt-8 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-8">
        {bots.map((bot) => (
          <Link
            key={bot.id}
            to={`/bot/${bot.id}`}
            className="group relative mx-auto flex w-full max-w-44 flex-col items-center rounded-2xl border border-apb-border-soft bg-apb-bg-card/80 p-4 text-center apb-glass-panel transition-all duration-240 hover:-translate-y-1 hover:border-apb-accent-cyan/70 hover:apb-glow-purple hover:shadow-xl focus-visible:outline-none focus-ring-neo"
            title={`View ${bot.name}`}
          >
            <div className="inline-flex w-32 h-32 sm:w-36 sm:h-36 items-center justify-center rounded-full p-[3px] bg-gradient-to-br from-apb-accent-purple via-apb-accent-cyan to-apb-accent-purple transition-transform duration-240 group-hover:scale-105">
              <div className="w-full h-full rounded-full bg-apb-bg-surface p-1.5 border border-white/5 shadow-inner overflow-hidden">
                <img
                  src={bot.image}
                  alt={bot.name}
                  className="block w-full h-full rounded-full object-cover"
                  style={{ transform: `scale(${bot.imageScale ?? 1})` }}
                />
              </div>
            </div>

            <div className="mt-4 max-w-40 text-center">
              <span className="block text-sm sm:text-base font-semibold text-white transition-colors duration-240 group-hover:text-apb-accent-cyan">
                {bot.name}
              </span>
              <span className="mt-2 mx-auto block h-1 w-10 rounded-full bg-gradient-to-r from-apb-accent-purple to-apb-accent-cyan opacity-65 group-hover:w-14 transition-all duration-240" />
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default BotAvatarGrid;
